import { useRouter } from 'next/router'
// import { useEffect, useState } from 'react'
import { Container } from '../../../components/Container'
import LatestPodcasts from '../../../components/Podcasts/PodcastsWithPagination'
import { PodCastAPI } from '../../../apis/PodcastAPI'
import ShallowHeader from '../../../components/ShallowHeader'

export default function CategoryPage({ categoryData, podcasts }) {
    const router = useRouter()

    // Handle fallback state if the page hasn't been generated yet
    if (router.isFallback) {
        return <div>Loading...</div>
    }

    return (
        <Container>
            <ShallowHeader title={'Category: ${categoryData.name}'} />
            <p>{categoryData?.description}</p>
            <LatestPodcasts
                title={`Category: ${categoryData.name}`}
                podcasts={podcasts}
            />
        </Container>
    )
}

// Fetching the slugs of all categories to generate the static paths
export async function getStaticPaths() {
    const categories = await PodCastAPI.getCategories() // Adjust this to your API or WP fetch
    const paths = categories.map((category) => ({
        params: { slug: category.slug },
    }))

    return {
        paths,
        fallback: true, // Enable fallback to generate pages on demand
    }
}

// Fetching data for each category based on the slug
export async function getStaticProps({ params }) {
    const categoryData = await PodCastAPI.getCategoryBySlug(params.slug) // Fetch category by slug
    const podcasts = await PodCastAPI.getPodcastsByCategory(categoryData.id) // Fetch podcasts under the category

    if (!categoryData || !podcasts) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            categoryData,
            podcasts,
        },
        revalidate: 10, // Revalidate the page every 10 seconds
    }
}
